"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeySubscribe = void 0;
var _objectPath = require("object-path");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var KeySubscribe = exports.KeySubscribe = /*#__PURE__*/_createClass(function KeySubscribe(store) {
  var _this = this;
  _classCallCheck(this, KeySubscribe);
  _defineProperty(this, "subscribers", {});
  _defineProperty(this, "prevState", void 0);
  _defineProperty(this, "store", void 0);
  _defineProperty(this, "subscribe", function (key, cb) {
    var instantState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (_this.subscribers.hasOwnProperty(key)) {
      _this.subscribers[key].push(cb);
    } else {
      _this.subscribers[key] = [cb];
    }

    //send current value.
    if (instantState) cb((0, _objectPath.get)(_this.store.getState(), key));

    // return "unsubscribe" function
    return function () {
      _this.subscribers[key] = _this.subscribers[key].filter(function (s) {
        return s !== cb;
      });
    };
  });
  var prevState = store.getState();
  this.store = store;
  store.subscribe(function () {
    var newState = store.getState();
    Object.keys(_this.subscribers).forEach(function (key) {
      if ((0, _objectPath.get)(prevState, key) !== (0, _objectPath.get)(newState, key)) {
        _this.subscribers[key].forEach(function (cb) {
          return cb((0, _objectPath.get)(newState, key));
        });
      }
    });
    prevState = newState;
  });
});
//# sourceMappingURL=KeySubscribe.js.map